import { enableMapSet } from 'immer';

import { ObjectId } from 'marketing-platform-lib/types';

import { createStore, Store } from './zustand';

type ExpandableObjectIdsState = {
  expandedObjectIds: Set<ObjectId>;
};
type ExpandableObjectIdsActions = {
  expandRow: (objectId: ObjectId) => void;
  collapseRow: (objectId: ObjectId) => void;
  collapseAll: () => void;
};
export type ExpandableObjectIdsSlice = ExpandableObjectIdsState &
  ExpandableObjectIdsActions;
export type ExpandableObjectIdsStore = Store<ExpandableObjectIdsSlice>;

export function createExpandableObjectIdsStore(): ExpandableObjectIdsStore {
  enableMapSet();
  return createStore<ExpandableObjectIdsSlice>(
    (set, __get, __api) => ({
      expandedObjectIds: new Set(),
      expandRow: (objectId: ObjectId) =>
        set((state) => {
          state.expandedObjectIds.add(objectId);
        }),
      collapseRow: (objectId: ObjectId) =>
        set((state) => {
          state.expandedObjectIds.delete(objectId);
        }),
      collapseAll: () => set({ expandedObjectIds: new Set() }),
    }),
    { devtools: { name: 'ExpandableObjectIdsStore' } }
  );
}
